import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/Icon/Icon';
import { map, filter } from 'lodash';
import {
  BreadCrumbsWrapper,
  BreadCrumb,
  Text,
  BreadCrumbInner,
} from './BreadCrumbs.styles.js';

const BreadCrumbs = (props) => {
  return (
    <BreadCrumbsWrapper>
      {map(
        filter(props.list, (l) => l.title),
        (l, i, a) => {
          return (
            <BreadCrumb key={i}>
              <BreadCrumbInner>
                {!l.title ? null : !l.link ? (
                  <Text>{l.title.replace(/-/g, ' ')}</Text>
                ) : (
                  <Link to={l.link}>
                    <Text link={l.link}>{l.title.replace(/-/g, ' ')}</Text>
                  </Link>
                )}
              </BreadCrumbInner>
              {i < a.length - 1 ? (
                <Icon
                  icon={'icon-chevron-right'}
                  fontSize={'9px'}
                  color="#76899e"
                />
              ) : null}
            </BreadCrumb>
          );
        }
      )}
    </BreadCrumbsWrapper>
  );
};

export default BreadCrumbs;
